import Booking from './booking';

export default Booking;